import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#202948",
      "fill-rule": "evenodd",
      d: "M10.814 2.513a1.753 1.753 0 1 1-3.506 0 1.753 1.753 0 0 1 3.506 0m.76 0a2.513 2.513 0 1 1-5.026 0 2.513 2.513 0 0 1 5.026 0M7.524 6.31h3.032a.04.04 0 0 1 .038.028l1.627 4.88a.84.84 0 0 1-.797 1.106H6.656a.84.84 0 0 1-.797-1.105l1.627-4.881a.04.04 0 0 1 .038-.028m-.76-.213a.8.8 0 0 1 .76-.547h3.032a.8.8 0 0 1 .76.547l1.626 4.881a1.6 1.6 0 0 1-1.518 2.106H6.656a1.6 1.6 0 0 1-1.518-2.106z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#202948",
      "fill-rule": "evenodd",
      d: "M16.11 2.03a1.271 1.271 0 1 1-2.542 0 1.271 1.271 0 0 1 2.542 0m.76 0a2.03 2.03 0 1 1-4.061 0 2.03 2.03 0 0 1 4.06 0m-3.162 3.215h2.229a.04.04 0 0 1 .038.027l1.145 3.435a.84.84 0 0 1-.797 1.106h-3.001a.84.84 0 0 1-.797-1.106l1.145-3.435a.04.04 0 0 1 .038-.027m-.76-.213a.8.8 0 0 1 .76-.547h2.229a.8.8 0 0 1 .759.547l1.145 3.435a1.6 1.6 0 0 1-1.518 2.106h-3.001a1.6 1.6 0 0 1-1.518-2.106zM4.39 2.03a1.271 1.271 0 1 1-2.542 0 1.271 1.271 0 0 1 2.542 0m.76 0a2.03 2.03 0 1 1-4.062 0 2.03 2.03 0 0 1 4.061 0M1.986 5.245h2.23a.04.04 0 0 1 .037.027L5.4 8.707a.84.84 0 0 1-.797 1.106h-3a.84.84 0 0 1-.798-1.106L1.95 5.272a.04.04 0 0 1 .038-.027m-.759-.213a.8.8 0 0 1 .76-.547h2.228a.8.8 0 0 1 .76.547L6.12 8.467a1.6 1.6 0 0 1-1.518 2.106h-3A1.6 1.6 0 0 1 .082 8.467z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }